import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BookPage } from './book';
import {ComponentsModule} from "../../components/components.module";

@NgModule({
  declarations: [
    BookPage,
  ],
  imports: [
    IonicPageModule.forChild(BookPage),
    ComponentsModule
  ],
})
export class BookPageModule {}



// WEBPACK FOOTER //
// ./src/pages/book/book.module.ts